import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './producaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, setFiltro, initForm, salvar, alterarOrdem, excluir, fecharDia, getLista, getListaSolicitacoes } from './producaoActions';
import { getLista as getListaParceiro } from '../parceiro/parceiroActions';
import { getLista as getListaRacao } from '../racao/racaoActions';
import { getLista as getListaUnidadeMedida } from '../unidadeMedida/unidadeMedidaActions';
import { getLista as getListaEquipamento } from '../equipamento/equipamentoActions';
import LabelAndInputDate from '../common/form/labelAndInputDate';

const columns = [{
    field: 'ordem',
    type: 'int'
}, {
    field: 'id',
    type: 'int'
}, {
    field: 'id_solicitacao',
    type: 'int'
}, {
    field: 'data_agendamento',
    type: 'date'
}, {
    field: 'nome_parceiro',
    type: 'text'
}, {
    field: 'nome_racao',
    type: 'text'
}, {
    field: 'quantidade',
    type: 'decimal'
}, {
    field: 'sigla_unidade_medida',
    type: 'text'
}];

class Producao extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'ordem',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaSolicitacoes();
		this.props.getListaParceiro();
		this.props.getListaRacao();
		this.props.getListaUnidadeMedida();
		this.props.getListaEquipamento();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.id}
					${item.id_solicitacao}
					${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}
					${item.nome_parceiro}
					${item.nome_racao}
					${FormatUtils.formatarValorTela(item.quantidade, 2)}
					${item.sigla_unidade_medida}
				`.toUpperCase().includes(pesquisar)
				);
		}).map(item => ({
			...item,
			quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
		}));

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						{/*<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />*/}

						<LabelAndInputDate
							label='Data'
							cols='12 1 1 1'
							value={this.props.filtro.data}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data: value
								});
							}} />

						<div style={{ marginTop: 8, width: 320 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaSolicitacoes();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ 
										itens: [],
										id_equipamento: this.props.listaEquipamento.length == 1 ? this.props.listaEquipamento[0].id : null
									});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<ExcelFile
								filename={'Producões'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.fecharDia(this.props.lista);
								}}>
								<i class='fas fa-check'></i> Fechar Dia
							</a>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='ordem'
									label='Ordem'
									width={100}
								/>

								<ThSort
									field='id'
									label='Número'
									width={10}
								/>

								<ThSort
									field='id_solicitacao'
									label='Solicitação'
									width={10}
								/>

								<ThSort
									field='data_agendamento'
									label='Agendamento'
									width={10}
								/>								
								
								<ThSort
									field='nome_parceiro'
									label='Parceiro'
									width={200}
								/>

								<ThSort
									field='nome_racao'
									label='Ração'
									width={200}
								/>

								<ThSort
									field='quantidade'
									label='Quantidade'
									width={80}
								/>

								<ThSort
									field='sigla_unidade_medida'
									label='Unidade Medida'
									width={100}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'center',
												alignItems: 'center'
											}}>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: 8,
													paddingRight: 8,
													width: 32,
													height: 32,
													fontWeight: 'bold',
													backgroundColor: '#6c757d',
													color: '#ffffff',
													borderRadius: '50%'
												}}>
												{item.ordem}
											</div>
											<div
												style={{
													width: 40
												}}>
												<ButtonTable
													type={'secondary'}
													width={32}
													small
													icon={'fas fa-angle-up'}
													visible={true}
													disabled={i == 0}
													event={() => {
														if (i > 0) {
															
															const itemAcima = lista.filter((item, pos) => pos == (i - 1))[0];

															this.props.alterarOrdem([{
																...itemAcima,
																ordem: item.ordem
															}, {
																...item,
																ordem: itemAcima.ordem
															}]);

														}
													}} />

												<ButtonTable
													type={'secondary'}
													width={32}
													small
													icon={'fas fa-angle-down'}
													visible={true}
													disabled={lista.length == (i+1)}
													event={() => {
														if (lista.length != (i+1)) {
															
															const itemAbaixo = lista.filter((item, pos) => pos == (i + 1))[0];

															this.props.alterarOrdem([{
																...itemAbaixo,
																ordem: item.ordem
															}, {
																...item,
																ordem: itemAbaixo.ordem
															}]);
														}
													}} />
												</div>
											</div>
									</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id_solicitacao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_agendamento)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_parceiro}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_racao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.quantidade}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.sigla_unidade_medida}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										{/*<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={!item.datahora_inicio}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />*/}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
				quantidade: parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2))
			}))} name='Producões'>
				{[
					{ componente: <ExcelColumn key={1} label='Ordem' value='ordem'/>},
					{ componente: <ExcelColumn key={2} label='Número' value='id'/>},
					{ componente: <ExcelColumn key={3} label='Solicitação' value='id_solicitacao'/>},
					{ componente: <ExcelColumn key={4} label='Agendamento' value='data_agendamento'/>},
					{ componente: <ExcelColumn key={5} label='Parceiro' value='nome_parceiro'/>},
					{ componente: <ExcelColumn key={6} label='Ração' value='nome_racao'/>},
					{ componente: <ExcelColumn key={7} label='Quantidade' value='capacidade' type='number'/>},
					{ componente: <ExcelColumn key={8} label='Unidade de Medida' value='sigla_unidade_medida'/>},
					{ componente: <ExcelColumn key={9} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={10} label='Usuário da Alteração' value='nome_usuario_alteproducao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.producao.modoTela,
	aguardando: state.producao.aguardando,
	filtro: state.producao.filtro,
	lista: state.producao.lista.filter(item => !item.datahora_confirmacao),
	listaEquipamento: state.equipamento.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, setFiltro, initForm, salvar, alterarOrdem, excluir, fecharDia, getLista, getListaSolicitacoes,
	getListaParceiro, getListaRacao, getListaUnidadeMedida, getListaEquipamento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Producao);